import Debug from 'debug'
import { Code, ConnectError } from '@connectrpc/connect'
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'

const debug = Debug('jotta:query')

const isTest =
  process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'development'

const queryCache = new QueryCache({
  onError: error => {
    debug(error)
  },
})

const mutationCache = new MutationCache({
  onError: error => {
    debug(error)
  },
})

/**
 * NOT_FOUND is not transient, so retrying cannot succeed. Retrying it caused
 * request storms when views held refs to photos deleted on other devices —
 * every missing photo multiplied into 4 requests, and batched fetches
 * multiplied whole batches.
 */
export function retryQueryOnError(failureCount: number, error: unknown) {
  if (error instanceof ConnectError && error.code === Code.NotFound) {
    return false
  }

  return failureCount < 3
}

export const queryClient = new QueryClient({
  queryCache,
  mutationCache,
  defaultOptions: {
    queries: {
      retry: isTest ? false : retryQueryOnError,
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
      throwOnError: true,
    },
    mutations: {
      throwOnError: true,
    },
  },
})
